
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gT9P9SWzCRPQQ0X4pBvySehwiqeZBXehrR34VcF6GkEQMeta } from "/codebuild/output/src3484966362/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexkVrd67c7EGX6uggCDCJKp_4JiSz9YXZ34jyUK0_45sYf0Meta } from "/codebuild/output/src3484966362/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search1xYAbshkWpG7mx6eYK1_45sECXdcCs9Ch1S_7p0k3W0HcMeta } from "/codebuild/output/src3484966362/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexa5mf069P1SQ7huVxG6dX5tHgF7cUe_450M5xBpG5df_vYMeta } from "/codebuild/output/src3484966362/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93PzpTcbpuyc_xR7BRyzjDXjukk432OikOxxgDsbL2jW0Meta } from "/codebuild/output/src3484966362/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index7eQ_45027ysBuzQ_1nwl0ZJ3E9scwSyhJ7rLLg5qXu2h8Meta } from "/codebuild/output/src3484966362/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93iv8GNnmbd2oWRipxO_45As4ZM72vAaJWGrpOL0vG83_45TwMeta } from "/codebuild/output/src3484966362/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index7iW1G_Hizw8IJqP71iDxwg7hk1AOdInO_m_Ih5_auDYMeta } from "/codebuild/output/src3484966362/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_936aBPGDa3LVR5P9IE1_4n7aJjQL40WcxTVhqxqYZudg8Meta } from "/codebuild/output/src3484966362/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index0OAPtf4_45Y4Xbm0u4twMd5x1eFK2CPDg0B94JcSFYtmAMeta } from "/codebuild/output/src3484966362/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexyEpr2jrwWIWSTLRmEbHiiO3XDa_452N9QDteI3HTkqFdIMeta } from "/codebuild/output/src3484966362/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3484966362/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3484966362/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3484966362/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3484966362/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3484966362/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index7eQ_45027ysBuzQ_1nwl0ZJ3E9scwSyhJ7rLLg5qXu2h8Meta || {},
    component: () => import("/codebuild/output/src3484966362/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3484966362/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index7iW1G_Hizw8IJqP71iDxwg7hk1AOdInO_m_Ih5_auDYMeta || {},
    component: () => import("/codebuild/output/src3484966362/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3484966362/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index0OAPtf4_45Y4Xbm0u4twMd5x1eFK2CPDg0B94JcSFYtmAMeta || {},
    component: () => import("/codebuild/output/src3484966362/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexyEpr2jrwWIWSTLRmEbHiiO3XDa_452N9QDteI3HTkqFdIMeta || {},
    component: () => import("/codebuild/output/src3484966362/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]